import { GET_DMX_CONTROLLERS, GET_DMX_CONTROLLERS_SUCCESS, GET_DMX_CONTROLLERS_ERROR } from './actionTypes';

export const getDmxControllers = (user) => {
  return {
    type: GET_DMX_CONTROLLERS,
    payload: { user },
  };
};

export const getDmxControllersSuccess = (controllers) => {
  return {
    type: GET_DMX_CONTROLLERS_SUCCESS,
    payload: { controllers },
  };
};

export const getDmxControllersError = (error) => {
  return {
    type: GET_DMX_CONTROLLERS_ERROR,
    payload: error,
  };
};
